import { SkeletonEmployerCardListLoading } from '@restworld/ui-components';
import { JobApplication } from '@restworld/utility-types';

import EmployerSpontaneousCandidatesCardsList from '../../../components/spontaneous-candidates/employer-spontaneous-candidates-cards-list';
import { cn } from '@restworld/utils-common';

function EmployerSpontaneousCandidatesContent({
  jobApplications,
  isLoading,
}: {
  jobApplications?: JobApplication[];
  isLoading?: boolean;
}) {
  return isLoading ? (
    <SkeletonEmployerCardListLoading />
  ) : (
    <ContentWrapper>
      <EmployerSpontaneousCandidatesCardsList jobApplications={jobApplications} />
    </ContentWrapper>
  );
}
export default EmployerSpontaneousCandidatesContent;

const ContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-1', className)} {...props} />
);
